
export default ({
  service,
  request,
  serviceForMock,
  requestForMock,
  mock,
  tools
}) => ({
  // 登录校验
  checkLogin(data = {}) {
    return request({
      url: '/api/student/checkLogin',
      method: 'post',
      params: data
    })
  },
  giftCodeActive(data = {}) {
    return request({
      url: '/api/student/giftCode/active',
      method: 'post',
      params: data
    })
  },
  logout(data = {}) {
    return request({
      url: '/api/student/logout',
      method: 'post',
      params: data
    })
  },
  detail(data = {}) {
    return request({
      url: '/api/student/detail',
      method: 'get',
      params: data
    })
  },
  checkPhoneAndIdCard(data = {}) {
    return request({
      url: '/api/student/checkPhoneAndIdCard',
      method: 'get',
      params: data
    })
  },
  verifyPhoneCode(data = {}) {
    return request({
      url: '/api/student/verifyPhoneCode',
      method: 'post',
      params: data
    })
  },
  resetPassword(data = {}) {
    return request({
      url: '/api/student/resetPassword',
      method: 'post',
      params: data
    })
  },
  checkPhone(data = {}) {
    return request({
      url: '/api/student/checkPhone',
      method: 'get',
      params: data
    })
  },
  divisionList(data = {}) {
    return request({
      url: '/api/student/division_list',
      method: 'get',
      params: data
    })
  },
  bindDivision(data = {}) {
    return request({
      url: '/api/student/bindDivision',
      method: 'post',
      params: data
    })
  },
  getServerList(data = {}) {
    return request({
      url: '/api/student/getServerList',
      method: 'get',
      params: data
    })
  },
})
